import React, { Component } from "react";
import Empty from "../../../base/features/blocks/Empty";
import Spinner from "../../../base/features/micro/Spinner";
import SimpleHeader from "../../../base/features/blocks/SimpleHeader";
import { apiService } from "../../../base/utils/service";
import { Link } from "react-router-dom";

class PostingMethods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      methods: null,
      shopUid: window.location.pathname.split("/")[2],
    };
  }
  componentDidMount() {
    this.getMethods();
  }
  getMethods() {
    apiService(`v1/shops/${this.state.shopUid}/shipping-configs`, "get").then(
      (data) => {
        if (data) {
          this.setState({
            methods: data.results,
          });
        }
      }
    );
  }
  changeActive(uid, active) {
    this.setState({ inputPending: true });
    apiService(
      `v1/shops/${this.state.shopUid}/shipping-configs/${uid}`,
      "PATCH",
      { active: !active }
    ).then((data) => {
      if (data) {
        this.getMethods();
      }
    });
    this.setState({ inputPending: false });
  }

  render() {
    return (
      <div className="container-fluid px-0">
        <SimpleHeader text="شیوه های ارسال" />
        <body style={{ marginTop: "80px" }}>
          {this.state.methods ? (
            <section>
              {this.state.methods.length === 0 && (
                <section className="pt-5">
                  <Empty
                    text={
                      "برای شروع فعالیت فروشگاه لازم است حداقل یک شیوه ارسال اضافه کنید."
                    }
                  />
                </section>
              )}
              {this.state.methods.map((method, m) => (
                <div
                  className="row mx-0 px-4 py-3 border-bottom position-relative"
                  key={m}
                >
                  <Link
                    className="position-absolute"
                    style={{
                      top: "0",
                      bottom: "0",
                      left: "0",
                      right: "0",
                      zIndex: "2",
                    }}
                    to={{
                      pathname: `/dashboard/${this.state.shopUid}/posting-methods/${method.uid}`,
                      state: {
                        methods: this.state && this.state.methods,
                      },
                    }}
                  ></Link>
                  <div className="col px-0 fw-bold color-main fs-5">
                    {method.provider && method.provider.title}
                  </div>
                  <div className="col-auto px-0" style={{ zIndex: "3" }}>
                    <input
                      disabled={this.state.inputPending}
                      className="form-check-input"
                      style={{ width: "20px", height: "20px" }}
                      value={method.active}
                      checked={method.active}
                      onChange={() =>
                        this.changeActive(method.uid, method.active)
                      }
                      type="checkbox"
                    />
                  </div>
                  <div className="col-12 px-0 mt-2">
                    <p className="mb-1 fw-bold fs-6">{method.title}</p>
                    <p className="mb-0 fw-bold text-secondary small">
                      {method.des}
                    </p>
                  </div>
                </div>
              ))}
            </section>
          ) : (
            <Spinner />
          )}
          <div className="row mx-0 mt-3">
            <div className="col-12 px-0 text-center">
              <Link
                to={{
                  pathname: `/dashboard/${this.state.shopUid}/posting-methods/add`,
                  state: {
                    methods: this.state && this.state.methods,
                  },
                }}
              >
                <button className="btn px-4 py-2 rounded28 border color-main fw-bold small">
                  افزودن شیوه ارسال
                </button>
              </Link>
            </div>
          </div>
        </body>
      </div>
    );
  }
}

export default PostingMethods;
